import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { productStore } from "../services/products";
import { productsService } from "../services/products/productsService";
// import { getCurrentUtcTime } from "../helper";

// required:  define initial state for cart module
export const collectionsInitialState = {
    brands: [],
    getFormatLoading:true,
    getFormatErr:null,
    getCategoryLoading:true,
    getCategoryErr:null,
    categories: null,
    brandCollections:[],
    banners:null,
    loadingCollection:true,
    error :null,
    activeBrand: null
}
export const getCategory = createAsyncThunk(
  'collections/getCategory',
  async (data, { rejectWithValue }) => {
    const { store_id,storeDetails } = data;
    try {
      const response = await productsService.getCategory(store_id,storeDetails);
      if (response.status === 200 ) {
        return {response: response?.data};
        
      } else {
        return rejectWithValue('Opps there seems to be an error in getCategory')
      }
    } catch (e) {
      return rejectWithValue('Opps there seems to be an error in getCategory')
    }
  }
)
export const getFormat = createAsyncThunk(
    'collections/getFormat',
    async (data, { rejectWithValue }) => {
        const {store_id, storeDetails} = data;
        try {
          const response = await productsService.getFormat(store_id, storeDetails);
          if (response.status === 200 && response?.data?.data?.home_screen) {
            const result = response?.data?.data?.home_screen?.filter(section=>section.type===2)
            const bannerSection = response?.data?.data?.home_screen?.filter(section=>section.type===1)
            let banners = null
            if(result.length>0 && result[0]?.data){
              if(bannerSection?.length>0 && Array.isArray(bannerSection[0]?.data?.banners)){
                banners = bannerSection[0]?.data?.banners.sort((a,b)=>(a.sequence - b.sequence))
              }
              return {getFormatData: result[0]?.data,banners:banners};
            }else{
              return rejectWithValue('Opps there seems to be an error')

            }
          } else {
            return rejectWithValue('Opps there seems to be an error')
          }
        } catch (e) {
          return rejectWithValue('Opps there seems to be an error')
        }
    }
  )
  export const getAllCollections = createAsyncThunk(
    'collections/getAllCollections',
    async (data,{rejectWithValue})=>{
      const {brands,store_id, storeDetails} = data;
      try{
        let result = await productsService.getAllProductsForBrands(brands,store_id, storeDetails)
        if(!Array.isArray(result?.data?.data)){
          throw new Error('something went wrong')
        }
				result = result?.data?.data?.map(brandData=>{
						let brandObj = brands.filter((item) => item.brand_id === brandData.brand_id)
						brandObj = brandObj.length>0? brandObj[0]: {}
									
						let collections = (brandData.collections && brandData.collections.length) ? brandData.collections.filter(coll => coll?.products?.length > 0) : [];
            if(Array.isArray(collections)){
              collections = collections.sort((a,b)=>a.sequence-b.sequence);
            }
              let products = collections.map(coll=>coll.products);
              collections.forEach(coll=>{
                if(Array.isArray(coll.products)){
                  coll.products = coll.products.sort((a,b)=>a.sequence-b.sequence);
                }
              })
							const mustTryData = products.flat().filter((i) => i.is_featured !== 0);
							const mustTryCollection = {
								collection_id: 1,
								collection_name:"Must Try",
								small_description: brandObj.brand_name,
								products: [...mustTryData],
								collection_imageUrl: brandObj.logo,
							};
							collections = [mustTryCollection,...collections]
							collections = collections.filter(coll=>coll?.products?.length>0)
						  return ({collections,brand:brandObj})
					} 

				)
        return {result}
      }catch(err){
        return rejectWithValue('Opps there seems to be an error')
      }
    }
  )
// required:  create slice for cart module with required reducers (actions)
export const collectionsSlice = createSlice({
    name: "collections",
    initialState: collectionsInitialState,
    reducers: {
        collectionsLoading: (state,action)=>{
            state.loadingCollection = true;
        },
        setCollectionsData:  (state, action) => {
            state.loadingCollection = false;
            state.brandCollections = action.payload.brandCollections;
            state.err = null;
        },
        setCollectionsErr: (state, action) => {
            state.err = {
                message: action.payload.message
            }
        },
        setActiveBrand: (state, {payload}) =>{
            if(payload?.brand_id){
                state.activeBrand = payload
            }else{
                state.activeBrand = null
            }
            
        },
        resetCollections: (state, {payload}) =>{
            state.activeBrand = null;
            state.brandCollections = [];
            state.brands = []
            state.categories = []
            state.loadingCollection = false;
            state.err = null

        }
    },
    extraReducers: {
        [getFormat.pending]: (state) => {
          state = {
            ...collectionsInitialState,
          }
          state.getFormatLoading = true;
        },
        [getFormat.fulfilled]: (state, { payload }) => {
          state.getFormatLoading = false
          state.brands = payload.getFormatData.brands;

          if(Array.isArray(payload.getFormatData.brands)){
            state.brands = payload.getFormatData.brands.sort((a,b)=>(a.sequence-b.sequence));
          }

          state.banners=payload.banners;
          state.getFormatErr = null
        },
        [getFormat.rejected]: (state,{payload}) => {
          state.getFormatLoading = false
          state.brands = null
          state.getFormatErr = {
            message: 'error loading getFormat'
          }
        },
        [getAllCollections.pending]: (state) => {
          state.loadingCollection = true;
          state.collectionError = null
        },
        [getAllCollections.fulfilled]: (state, { payload }) => {
          state.loadingCollection = false;
          state.brandCollections = payload.result;
          state.collectionError = null;
        },
        [getAllCollections.rejected]: (state,{payload}) => {
          state.getFormatLoading = false;
          state.loadingCollection = false;
          state.collectionError = {
            message: 'error loading getFormat'
          }
        },
        [getCategory.pending]: (state) => {
          state.getCategoryLoading = true;
        },
        [getCategory.fulfilled]: (state, { payload }) => {
          state.getCategoryLoading = false
          state.categories = payload.response;
          state.getCategoryErr = null
        },
        [getCategory.rejected]: (state,{payload}) => {
          state.getCategoryLoading = false
          state.categories = null
          state.getCategoryErr = {
            message: 'error loading getCategory'
          }
        },

      },
});

// required: export all defined reducer functions as actions
export const {
    collectionsLoading,
    setCollectionsData,
    setActiveBrand,
    setCollectionsErr,
    resetCollections
} = collectionsSlice.actions;

// required: export complete reducer
export default collectionsSlice.reducer;